@import "mixins";

:host {
  @include socialauthlinks__appleid-signin;

  cursor: pointer;

  [role="button"] {
    max-width: 100% !important;
  }
}
